const quotes = [
  {
    arabic: 'إِنَّ أَمْثَلَ مَا تَدَاوَيْتُمْ بِهِ الْحِجَامَةُ',
    french: '« La meilleure thérapie que vous utilisez est la Hijama »',
    source: 'Sahih Bukhari',
  },
  {
    arabic: 'الشِّفَاءُ فِي ثَلَاثَةٍ: شَرْبَةِ عَسَلٍ، وَشَرْطَةِ مِحْجَمٍ، وَكَيَّةِ نَارٍ',
    french:
      "« La guérison se trouve en trois choses : une gorgée de miel, une saignée par ventouse, et la cautérisation — mais j'interdis à ma communauté la cautérisation »",
    source: 'Sahih Bukhari',
  },
  {
    arabic:
      "مَا مَرَرْتُ لَيْلَةَ أُسْرِيَ بِي بِمَلَإٍ إِلَّا قَالُوا: يَا مُحَمَّدُ، مُرْ أُمَّتَكَ بِالْحِجَامَةِ",
    french:
      "« Lors de la nuit du voyage nocturne, je ne passais devant aucun groupe d'anges sans qu'ils me disent : \"Ô Muhammad, ordonne à ta communauté de pratiquer la ventouse\" »",
    source: 'Sunan Ibn Majah',
  },
];

export default function ProphetQuotes() {
  return (
    <section
      id="paroles-prophete"
      className="relative py-16 px-6 bg-[#07271f] overflow-hidden scroll-mt-[84px]"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 70% 55% at 50% 30%, rgba(15,90,68,.35) 0%, transparent 70%)',
        }}
      />
      <div className="relative max-w-[820px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-[#8fd6b8] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Médecine Prophétique
          </span>
          <h2
            className="text-[clamp(28px,4vw,40px)] font-bold text-[#f7f3ea] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Paroles du Prophète ﷺ
          </h2>
          <p className="text-[#f2ede2]/50 max-w-xl mx-auto text-sm leading-relaxed">
            Le Prophète Muhammad ﷺ a recommandé la thérapie par ventouses dans de nombreux hadiths
            authentiques, en faisant l&apos;un des remèdes les plus bénis.
          </p>
        </div>

        <div className="space-y-6">
          {quotes.map((q) => (
            <div
              key={q.arabic.slice(0, 20)}
              className="bg-[#f2ede2]/5 border border-[#8fd6b8]/20 rounded-2xl p-7 flex flex-col md:flex-row gap-6 items-start"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#0b6b52]/40 text-[#8fd6b8]">
                <i className="ri-double-quotes-l text-lg"></i>
              </div>
              <div className="flex-1">
                <p
                  className="text-[#c9ecd9] text-lg leading-loose mb-3 text-right"
                  dir="rtl"
                  style={{ fontFamily: "'Amiri', serif" }}
                >
                  {q.arabic}
                </p>
                <p className="text-[#f7f3ea]/80 text-sm leading-relaxed italic mb-3">{q.french}</p>
                <span className="inline-flex items-center gap-1.5 text-xs text-[#8fd6b8] font-semibold bg-[#0b6b52]/30 px-3 py-1 rounded-full">
                  <i className="ri-book-open-line"></i>
                  {q.source}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
